export const enumerable = (value: boolean): any => {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor): void {
    descriptor.enumerable = value;
  };
};
